import { makeAutoObservable, runInAction } from "mobx";
import { access_key, baseUrl } from "./main";
import {
  parseFetchErrorResponse,
  pickAnyFieldError
} from "./apiErrorParser";

const md5 = require("md5");

class UsersStore {
  token = "";
  approvedPhone = "";
  error = false;
  isLoading = false;

  userData = [];
  userFiles = [];
  userRequired = null;
  errorRegistration = "";
  errorCode = "";
  successRequestMoney = "";
  preToken = "";
  prePhone = "";
  prePassword = "";
  registration = "";

  getLocalStorageOrDefault = (key, defaultValue) => {
    const stored = localStorage.getItem(key);
    if (!stored) {
      return defaultValue;
    }
    return stored;
  };

  componentDidMount() {
    this.token = this.getLocalStorageOrDefault("token", false);
  }

  setLocalStorage = (key, value) => {
    localStorage.setItem(key, value);
  };

  constructor(instance) {
    this.rootStore = instance;
    makeAutoObservable(this, {}, { deep: true });
    this.token = this.getLocalStorageOrDefault("token", false);
  }

  changeToken = (token) => {
    this.token = token;
    this.error = false;
    window.localStorage.removeItem("token");
  };

  cleanErrorRegistration = () => {
    this.errorRegistration = "";
    this.error = false;

    this.errorCode = "";
    this.approvedPhone = "";
  };

  checkPhoneCode = async () => {
    let bodyCredentials = new FormData();
    bodyCredentials.append("access_key", access_key);
    bodyCredentials.append("phone", this.prePhone.replace(/[^\d]+/g, ""));

    return fetch(
      `${baseUrl}/crm/massrecruitment/api/setdata?action=phone_approve_send_code`,
      {
        method: "POST",

        body: bodyCredentials
      }
    )
      .then((response) => {
        if (response.ok) {
          return;
        } else {
          runInAction(() => {
            this.error = true;
          });
        }
      })
      .catch(() => {
        runInAction(() => {
          this.error = true;
        });
      });
  };

  getUserData = async (data) => {
    this.isLoading = true;

    let bodyCredentials = new FormData();
    bodyCredentials.append("access_key", access_key);

    return fetch(
      `${baseUrl}/crm/massrecruitment/api/getdata?action=agents_one`,
      {
        method: "POST",
        headers: {
          "ACCESS-TOKEN": data.newToken
        },
        body: bodyCredentials
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          this.error = true;
        }
      })
      .then((response) => {
        runInAction(() => {
          if (response["agent"]["phone_approved"] === "1") {
            this.userData = response["agent"];
            this.userFiles = response["files"];
            this.userRequired = response["required"];
            this.token = data.newToken;
            this.setLocalStorage("token", data.newToken);
            this.approvedPhone = "1";
          } else {
            this.approvedPhone = "0";
            this.checkPhoneCode();
            this.prePhone = response["agent"]["phone"];
          }
          this.isLoading = false;
        });
      })
      .catch(() => {
        runInAction(() => {
          this.error = true;
          this.isLoading = false;
        });
      });
  };

  loginUser = async (credentials) => {
    let bodyCredentials = new FormData();
    bodyCredentials.append("access_key", access_key);
    bodyCredentials.append("phone", credentials.phone.replace(/[^\d]+/g, ""));
    bodyCredentials.append("password_hash", md5(credentials.password));

    return fetch(`${baseUrl}/crm/massrecruitment/api/autorization`, {
      method: "POST",

      body: bodyCredentials
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          this.error = true;
        }
      })
      .then((response) => {
        runInAction(() => {
          this.preToken = response["token"];
          this.prePhone = credentials.phone;
          this.prePassword = credentials.password;

          return this.getUserData({ newToken: this.preToken });
        });
      })
      .catch(() => {
        runInAction(() => {
          this.error = true;
        });
      });
  };

  logoutUser = async () => {
    const bodyCredentials = new FormData();
    bodyCredentials.append("access_key", access_key);

    await fetch(`${baseUrl}/crm/massrecruitment/api/logout`, {
      method: "POST",
      headers: {
        "ACCESS-TOKEN": this.token
      },
      body: bodyCredentials
    })
      .then((response) => response.json())
      .catch(() => runInAction(() => (this.error = true)));
  };

  passwordReset = async (credentials) => {
    let bodyCredentials = new FormData();
    bodyCredentials.append("access_key", access_key);
    bodyCredentials.append("phone", credentials.phone.replace(/[^\d]+/g, ""));

    this.errorRegistration = "";
    this.error = false;

    try {
      const response = await fetch(
        `${baseUrl}/crm/massrecruitment/api/setdata?action=password_reset`,
        {
          method: "POST",
          body: bodyCredentials
        }
      );

      if (response.ok) return true;

      const parsed = await parseFetchErrorResponse(response);
      runInAction(() => {
        this.errorRegistration =
          parsed.message ||
          pickAnyFieldError(parsed.fieldErrors) ||
          "Не удалось сменить пароль. Попробуйте ещё раз.";
      });
      return false;
    } catch {
      runInAction(() => {
        this.error = true;
        this.errorRegistration = "Не удалось сменить пароль. Попробуйте ещё раз.";
      });
      return false;
    }
  };

  refreshUserData = async (data) => {
    this.isLoading = true;

    let bodyCredentials = new FormData();
    bodyCredentials.append("access_key", access_key);
    bodyCredentials.append("email", data.email);
    bodyCredentials.append("phone", data.phone.replace(/[^\d]+/g, ""));
    bodyCredentials.append(
      "password_hash",
      data.password ? md5(data.password) : this.userData["password"]
    );
    bodyCredentials.append("surname", data.surname);
    bodyCredentials.append("name", data.name);
    bodyCredentials.append("patronymic", data.patronymic);
    bodyCredentials.append("birthday", data.birthday);
    bodyCredentials.append("region_of_residence", data.region_of_residence);
    bodyCredentials.append("birth_place", data.birth_place);
    bodyCredentials.append("offer_apply", data.contract);
    bodyCredentials.append("passport_number", data.passport_number);
    bodyCredentials.append("passport_series", data.passport_series);
    bodyCredentials.append("passport_code", data.passport_code);
    data.passport_date !== "" &&
      bodyCredentials.append("passport_date", data.passport_date);
    bodyCredentials.append("passport_place", data.passport_place);

    bodyCredentials.append("passport_propiska", data.passport_propiska);
    bodyCredentials.append("snils", data.snils);
    bodyCredentials.append("inn", data.inn);
    bodyCredentials.append("bank_payment_account", data.bankaccount);
    bodyCredentials.append("bank_name", data.bankname);
    bodyCredentials.append("bank_recipient", data.bank_recipient);
    bodyCredentials.append("bank_inn", data.banknumber);
    bodyCredentials.append("bank_bik", data.bankbik);
    bodyCredentials.append("bank_kpp", data.bankkpp);
    bodyCredentials.append("bank_correspondent_account", data.bankkor);

    bodyCredentials.append("contract_type", data.contract_type);

    return fetch(
      `${baseUrl}/crm/massrecruitment/api/setdata?action=agents_update`,
      {
        method: "POST",
        headers: {
          "ACCESS-TOKEN": this.token
        },
        body: bodyCredentials
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          this.error = true;
        }
      })
      .then(() => {
        runInAction(() => {
          this.getUserData({ newToken: this.token });
          this.isLoading = false;
        });
      })
      .catch(() => {
        runInAction(() => {
          this.error = true;
          this.isLoading = false;
        });
      });
  };

  newRegistration = async (data) => {
    let bodyCredentials = new FormData();
    bodyCredentials.append("access_key", access_key);
    bodyCredentials.append("email", data.email);
    bodyCredentials.append("phone", data.phone.replace(/[^\d]+/g, ""));
    bodyCredentials.append("password_hash", md5(data.password));
    bodyCredentials.append("surname", data.surname);
    bodyCredentials.append("name", data.firstname);
    bodyCredentials.append("patronymic", data.patronymic);
    bodyCredentials.append("birthday", data.birthday);
    bodyCredentials.append("offer_apply", data.contract);

    this.errorRegistration = "";
    this.error = false;

    try {
      const response = await fetch(
        `${baseUrl}/crm/massrecruitment/api/setdata?action=agents_add`,
        {
          method: "POST",
          body: bodyCredentials
        }
      );

      runInAction(() => {
        this.prePhone = data.phone;
        this.prePassword = data.password;
      });

      if (response.ok) {
        runInAction(() => {
          this.loginUser({
            phone: this.prePhone,
            password: this.prePassword
          });
          this.registration = true;
          this.rootStore.modalWindows.setRegistrationModal(false);
        });
        return;
      }

      const parsed = await parseFetchErrorResponse(response);
      runInAction(() => {
        this.errorRegistration =
          parsed.message ||
          pickAnyFieldError(parsed.fieldErrors) ||
          "Не удалось зарегистрироваться. Попробуйте ещё раз.";
      });
    } catch {
      runInAction(() => {
        this.error = true;
        this.errorRegistration =
          "Не удалось зарегистрироваться. Попробуйте ещё раз.";
      });
    }
  };

  approvePhoneCode = async (data) => {
    let bodyCredentials = new FormData();
    bodyCredentials.append("access_key", access_key);
    bodyCredentials.append("phone", this.prePhone.replace(/[^\d]+/g, ""));
    bodyCredentials.append("code", data.code);

    return fetch(
      `${baseUrl}/crm/massrecruitment/api/setdata?action=phone_approve_validate_code`,
      {
        method: "POST",

        body: bodyCredentials
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          this.error = true;
        }
      })
      .then((response) => {
        runInAction(() => {
          if (response["success"] === false) {
            this.errorCode = "Код введен неверно";
          } else {
            this.loginUser({
              phone: this.prePhone,
              password: this.prePassword
            });
            this.errorCode = "Код введен верно";
          }
        });
      })
      .catch(() => {
        runInAction(() => {
          this.error = true;
        });
      });
  };

  sendRquestForMoney = async () => {
    this.isLoading = true;

    let bodyCredentials = new FormData();
    bodyCredentials.append("access_key", access_key);

    return fetch(
      `${baseUrl}/crm/massrecruitment/api/setdata?action=payment_request`,
      {
        method: "POST",
        headers: {
          "ACCESS-TOKEN": this.token
        },
        body: bodyCredentials
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          this.error = true;
        }
      })
      .then((response) => {
        runInAction(() => {
          this.successRequestMoney = response.success;

          this.isLoading = false;
        });
      })
      .catch(() => {
        runInAction(() => {
          this.error = true;
          this.isLoading = false;
        });
      });
  };
}

export default UsersStore;
